import * as React from 'react';


// Permite ejecutar un useEffect sólo una vez. Está pensado para poder evitar que se ejecute dos veces 
// el useEffect cuando en desarrollo tenemos activado el React.StrictMode.
export function useEffectOnce(action: () => void) {
	return React.useEffect(() => {
		const interval = setTimeout(action, 50);
		return () => clearTimeout(interval);
	}, [action]);
}